module.exports = __webpack_public_path__ + "2aebf44be4a1dbd049a81e13a18837de.webp";